import { assign } from "xstate";
import { addValueCookie, deleteCookie } from "../Utilities/httpUtils";
import { docTypes, MINUTES_CONVERTER_COOKIE, codesNoSDK, sourceId, desktopDomain } from "../Constants/Constants";
import config from "src/config";
import { saveClientLogs, sendNotifyDesktop, clearSession } from "../../Services/httpServices";

export const actions = {
  setJweKey: assign({ jweKey: (_context, event) => event.data.jwe }),
  setAesKey: assign({ aesKey: (_context, event) => event.data.aesKey }),
  setDataStr: assign({ dataStr: (_context, event) => event.data.dataStr }),
  setDefaultServiceError: assign({ code: _context => codesNoSDK.errorServiceConsume.code }),
  setServiceError: assign({ code: (_context, event) => event.data.response.data.resultCode }),
  setJwsValue: assign({ jws: (_context, event) => event.data.response.data.jws || "" }),
  setSso: assign({ cookie: (_context, event) => event.data.cookie }),
  setSetSession: assign({ sessionId: (_context, event) => event.data.sessionId }),
  setSetDataCookie: assign({ dataCookie: (_context, event) => event.data.dataCookie }),
  setSuccessGeneretingKey: assign({ codeLog: _context => 'successGeneretingKey' }),
  setDataResponse: assign({ dataResponse: (_context, event) => event.data.data }),
  setCodeResult: assign({ code: (_context, event) => event.data.resultCode }),
  setCodeError: assign({ code: (_context, event) => event.code }),
  setUrlQR: assign({ urlQR: (_context, event) => event.data.resultUrl }),
  setLogQr: assign({ codeLog: _context => 'initQR' }),
  setLogQrSuccess: assign({ codeLog: _context => 'successQR' }),
  clearResultCode: assign({ resultLog: _context => "" }),
  setDeviceType: assign({ deviceType: (_context, event) => event.deviceType }),
  setIsDesktopProcessInMobile: assign({ isDesktopProcessInMobile: (_context, event) => event.isDesktopProcessInMobile }),
  setIsTestMode: assign({ isTestMode: (_context, event) => event.isTestMode })
};

export const machineActions = {
  redirectToTarget: _context => {
    const base = `${_context.redirectUrl}/?Code=${codesNoSDK.successCode.code}&Data=${_context.dataResponse}`;
    const full = _context.customerTransactionUrl ? `${base}&customerTransaction=${_context.customerTransactionUrl}` : base;
    window.location.replace(full);
  },
  redirectToTargetError: _context => {
    let urlRedirect = `${_context.redirectUrl}/?Code=${_context.code}`;
    if (_context.customerTransactionUrl) {
      urlRedirect += `&customerTransaction=${_context.customerTransactionUrl}`;
    }
    if (_context.jws) {
      urlRedirect += `&jws=${_context.jws}`;
    }
    window.location.replace(urlRedirect);
  },
  documentEquivalent: assign(_context => {
    return { documentTypeEq: docTypes[_context.documentType] };
  }),
  saveCookiesInBrowser: _context => {
    const expiration = parseInt(config.TIME_SSOFUB) * MINUTES_CONVERTER_COOKIE;
    if (_context.cookie && _context.sessionId) {
      addValueCookie("SSOFUB", expiration, _context.cookie);
      addValueCookie("SSNFUB", expiration, _context.sessionId);
      addValueCookie("JWEFUB", expiration, _context.data);
    }
  },
  saveCookiePrevalidate: _context => {
    const expiration = parseInt(config.TIME_SSOFUB) * MINUTES_CONVERTER_COOKIE;
    if (_context.cookie && _context.sessionId) {
      addValueCookie("SSOFUB", expiration, _context.cookie);
      addValueCookie("SSNFUB", expiration, _context.sessionId);
      addValueCookie("JWEFUB", expiration, _context.data);
    }
  },
  deleteCookiesInBrowser: () => {
    deleteCookie("SSOFUB");
    deleteCookie("SSNFUB");
    deleteCookie("JWEFUB");
  },
  saveLogs: _context => {
    const result = { code: _context.codeLog };
    const deviceType = _context.deviceType ? sourceId.web : sourceId.mobile;
    saveClientLogs(_context, deviceType, codesNoSDK, result, _context.resultLog);
  },
  sendFrontMessage: _context => {
    // we do not send messages if error is from backend
    if (!_context.notifyDesktop) {
      return;
    }
    sendNotifyDesktop(_context);
  },
  resetHistory: _context => {
    history.pushState(null, "", desktopDomain);
  },
  closeSession: _context => {
    if(_context.cookie){
      clearSession(_context);
    }
  },
  redirectToNewFront: _context => {
    window.location.replace(`${_context.redirectUrl}&trs=true`);
  },
};
